<div class="header-container">
  <div class="header-image-container">
    <a routerLink="/" data-testid="app-logo-link">
      <div class="logo-info">
        <img
          ngSrc="assets/images/netsmart-color-logo.jpg"
          height="19"
          width="34"
          class="header-image"
          data-testid="app-logo-img"
          alt="Netsmart CareConnect - Console home"
          i18n-alt
        />
        <h1 class="header-title">CareConnect</h1>
      </div>
    </a>

    <nav class="tabs" role="navigation" aria-label="Main navigation" i18n-aria-label>
      @for (tab of tabs; track tab.label) {
        <a [routerLink]="tab.route"
           [routerLinkActiveOptions]="{exact: false}"
           [attr.aria-current]="rla.isActive ? 'page' : null"
           routerLinkActive="active"
           #rla="routerLinkActive"
           class="nav-item"
        >{{ tab.label }}</a>
      }
    </nav>
  </div>

  <div class="user-details dropdown" data-testid="user-profile">
    <span class="header-info-text" i18n>Console</span>
    <fa-icon [icon]="faCircleUser" class="caret-icon" aria-hidden="true" [size]="'lg'" />
    <button class="dropbtn"
            (click)="toggleDropdown()"
            [attr.aria-expanded]="isDropdownOpen()"
            [attr.aria-controls]="menuId"
            aria-haspopup="menu"
            aria-label="Open user menu"
            i18n-aria-label
    >
      <span class="menu-text">{{ username() }}</span>
      <fa-icon
        [icon]="isDropdownOpen() ? faCaretUp : faCaretDown"
        class="caret-icon"
        aria-hidden="true"
      />
    </button>
    <div class="dropdown-content-container" [ngClass]="{
            'visually-hidden': !isDropdownOpen()
          }"
         [attr.aria-hidden]="!isDropdownOpen()"
         role="menu"
         [id]="menuId"
    >
      <div class="dropdown-content">
        <div class="nav-link">
          <button
            class="name-class"
            (click)="onItemSelect('settings'); toggleDropdown();"
            role="menuitem"
            type="button"
            i18n
          >Okta Settings</button>
        </div>
        <div class="nav-link">
          <button
            class="name-class"
            (click)="onItemSelect('signOut'); toggleDropdown();"
            role="menuitem"
            type="button"
            i18n
          >Sign out</button>
        </div>
      </div>
    </div>
  </div>
</div>
